export default __webpack_public_path__ + "static/google-play-badge-ade5203de1800d37cb7d26f7687989c3.svg";